type FormSubmitButton = {
  children: React.ReactNode;
  disabled?: boolean;
  loading?: boolean;
  bgColor?: string;
  textColor?: string;
  borderColor?: string;
};

export const FormSubmitButton: React.VFC<FormSubmitButton> = ({
  children,
  loading,
  disabled = false,
  bgColor = "bg-blue-700",
  textColor = "text-white",
  borderColor = "border-blue-700",
}) => {
  return (
    <button
      type="submit"
      className={`relative text-blue-700 font-bold rounded inline-block px-8 py-3 border border-blue-700 hover:bg-blue-700 hover:text-white duration-300 ${borderColor} ${bgColor} ${textColor} ${
        loading ? "opacity-70 pointer-events-none select-none" : ""
      }`}
      disabled={loading || disabled}
    >
      <span className={`${loading ? "text-transparent" : ""}`}>{children}</span>
      <span
        className={`${
          loading
            ? "flex items-center justify-center absolute top-0 left-0 bottom-0 right-0"
            : "overflow-hidden hidden"
        }`}
      >
        <span className={"text-sm"}>Loading...</span>
      </span>
    </button>
  );
};
